export default __webpack_public_path__ + "static/NBInternationalPro-Medium-f74079f16a2f93f37accaaf7e3858db4.eot";